import { render } from "./FileDownload.vue?vue&type=template&id=9027c8d4"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__